/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The types of resource statuses.
 */
export enum DeviceResourceStatusType {
  DeviceResourceStatusHealthy = 'Healthy',
  DeviceResourceStatusWarning = 'Warning',
  DeviceResourceStatusCritical = 'Critical',
  DeviceResourceStatusError = 'Error',
  DeviceResourceStatusUnknown = 'Unknown',
}
